import { buttonBase } from "../styles/layoutStyles";
import { documentCardStyle } from "../styles/reportStyles";

export function ExtractionHpReport({ uploading, disabled = false, onUpload }) {
    const locked = uploading || disabled;
    return (
        <div style={documentCardStyle}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
                <div style={{ display: "grid", gap: "4px" }}>
                    <h2 style={{ margin: 0, color: "#0f172a", fontSize: "22px", fontWeight: 950 }}>
                        Extraction des HP
                    </h2>
                    <p style={{ margin: 0, color: "#64748b", fontSize: "13px" }}>
                        Importez le document d'extraction des HP.
                    </p>
                </div>
                <label style={{
                    ...buttonBase,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    background: "#2563eb",
                    borderColor: "#2563eb",
                    color: "white",
                    fontWeight: 900,
                    cursor: locked ? "not-allowed" : "pointer",
                    opacity: locked ? 0.65 : 1,
                }}>
                    {disabled ? "Pré-production figée" : uploading ? "Import..." : "Importer un document"}
                    <input
                        type="file"
                        accept="application/pdf,image/png,image/jpeg"
                        multiple
                        disabled={locked}
                        onChange={event => {
                            onUpload(event.target.files);
                            event.target.value = "";
                        }}
                        style={{ display: "none" }}
                    />
                </label>
            </div>
        </div>
    );
}
